// IMPORTANT!!
// FILE DEPRECATED
//USE benchmarks-new.ts







import { createSelector } from "../reselect";
import {
  getNewStatsService,
  total,
  simpleChart,
  simpleChart2,
  safeDivide,
  avg,
} from "../generalUtils";

const services = ["facebook", "google", "tiktok", "snapchat", "pinterest"];
const getNewStats = getNewStatsService("benchmarks");


const getNewStatsWithBlended = createSelector([getNewStats], (stats) => {
  const retVal = stats.map((day) => {
    return {
      ...day,
      hours: [
        {
          ...day.hours[0],
          blended_spend: services
            .map((service) => parseInt(day.hours[0][`spend_${service}_avg`]))
            .reduce((acc, spend) => acc + spend, 0),
          blended_full_spend: services
            .map((service) => parseInt(day.hours[0][`spend_${service}`]))
            .reduce((acc, spend) => acc + spend, 0),
          blended_clicks: services
            .map((service) => parseInt(day.hours[0][`clicks_${service}`]))
            .reduce((acc, spend) => acc + spend, 0),
          blended_impressions: services
            .map((service) => parseInt(day.hours[0][`impressions_${service}`]))
            .reduce((acc, spend) => acc + spend, 0),
          blended_cv: services
            .map((service) =>
              parseInt(day.hours[0][`conversionValue_${service}`])
            )
            .reduce((acc, spend) => acc + spend, 0),
        },
      ],
    };
  });
  return retVal;
});

// Benchmarks blended (all channels)

const totalBenchmarksOrdersAvg = createSelector([getNewStats], (stats) => {
  return total(stats, "orders");
});

const chartBenchmarksOrdersAvg = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, "orders");
});

const totalBenchmarksNewCustomersTotalPriceAvg = createSelector(
  [getNewStats],
  (stats) => {
    return total(stats, "new_customer_total_price");
  }
);

const chartBenchmarksNewCustomersTotalPriceAvg = createSelector(
  [getNewStats],
  (stats) => {
    return simpleChart(stats, "new_customer_total_price");
  }
);

const totalBenchmarksNewCustomersAvg = createSelector(
  [getNewStats],
  (stats) => {
    return total(stats, "new_customer_orders");
  }
);

const chartBenchmarksFBAdsNewCustomersAvg = createSelector(
  [getNewStats],
  (stats) => {
    return simpleChart(stats, "new_customer_orders");
  }
);

const totalBenchmarksSize = createSelector([getNewStats], (stats) => {
  return total(stats, "size");
});

const chartBenchmarksSize = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, "size");
});

const totalBenchmarksTotalSpendAvg = createSelector([getNewStats], (stats) => {
  return total(stats, "total_spend_usd");
});

const chartBenchmarksTotalSpendAAvg = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, "total_spend_usd");
});

// Facebook ads benchmarks
const totalBenchmarksTotalConversionValueAvg = createSelector(
  [getNewStats],
  (stats) => {
    return total(stats, "conversionValue_facebook");
  }
);

const chartBenchmarksTotalConversionValueAvg = createSelector(
  [getNewStats],
  (stats) => {
    return simpleChart(stats, "conversionValue_facebook");
  }
);

const totalBenchmarksFBAdsSpend = createSelector([getNewStats], (stats) => {
  return total(stats, "spend_facebook");
});
const chartBenchmarksFBAdsSpend = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, "spend_facebook");
});


const totalBenchmarksFBAdsSpendAvg = createSelector([getNewStats], (stats) => {
  return total(stats, "spend_facebook_avg");
});
const chartBenchmarksFBAdsSpendAvg = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, "spend_facebook_avg");
});

const totalBenchmarksFBAdsImpressionsAvg = createSelector(
  [getNewStats],
  (stats) => {
    return total(stats, "impressions_facebook");
  }
);

const chartBenchmarksFBAdsImpressionsAvg = createSelector(
  [getNewStats],
  (stats) => {
    return simpleChart(stats, "impressions_facebook");
  }
);

const totalBenchmarksFBAdsClicksAvg = createSelector([getNewStats], (stats) => {
  return total(stats, "clicks_facebook");
});

const chartBenchmarksFBAdsClicksAvg = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, "clicks_facebook");
});

const benchmarksFacebookRoas = createSelector(
  [totalBenchmarksTotalConversionValueAvg, totalBenchmarksFBAdsSpend],
  (conversionValue, spend) => safeDivide(conversionValue, spend)
);

const chartBenchmarksFacebookRoas = createSelector(
  [chartBenchmarksTotalConversionValueAvg, chartBenchmarksFBAdsSpend],
  (conversionValue, spend) => simpleChart2(conversionValue, spend)
);


// tiktok ads benchmarks

const totalBenchmarksTotalConversionValueTiktokAvg = createSelector(
  [getNewStats],
  (stats) => {
    return total(stats, "conversionValue_tiktok");
  }
);
const chartBenchmarksTotalConversionValueTiktokAvg = createSelector(
  [getNewStats],
  (stats) => {
    return simpleChart(stats, "conversionValue_tiktok");
  }
);

const totalBenchmarksTiktokAdsSpend = createSelector([getNewStats], (stats) => {
  return total(stats, "spend_tiktok");
});
const chartBenchmarksTiktokAdsSpend = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, "spend_tiktok");
});

const totalBenchmarksTiktokAdsSpendAvg = createSelector([getNewStats], (stats) => {
  return total(stats, "spend_tiktok_avg");
});
const chartBenchmarksTiktokAdsSpendAvg = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, "spend_tiktok_avg");
});

const totalBenchmarksTiktokAdsImpressionsAvg = createSelector(
  [getNewStats],
  (stats) => {
    return total(stats, "impressions_tiktok");
  }
);

const chartBenchmarksTiktokAdsImpressionsAvg = createSelector(
  [getNewStats],
  (stats) => {
    return simpleChart(stats, "impressions_tiktok");
  }
);

const totalBenchmarksTiktokAdsClicksAvg = createSelector([getNewStats], (stats) => {
  return total(stats, "clicks_tiktok");
});

const chartBenchmarksTiktokAdsClicksAvg = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, "clicks_tiktok");
});

const benchmarksTiktokRoas = createSelector(
  [totalBenchmarksTotalConversionValueTiktokAvg, totalBenchmarksTiktokAdsSpend],
  (conversionValue, spend) => safeDivide(conversionValue, spend)
);

const chartBenchmarksTiktokRoas = createSelector(
  [chartBenchmarksTotalConversionValueTiktokAvg, chartBenchmarksTiktokAdsSpend],
  (conversionValue, spend) => simpleChart2(conversionValue, spend)
);

const totalBenchmarksCPCTiktok = createSelector(
  [totalBenchmarksTiktokAdsSpend, totalBenchmarksTiktokAdsClicksAvg],
  (spend, clicks) => safeDivide(spend, clicks)
);
const chartBenchmarksCPCTiktok = createSelector(
  [chartBenchmarksTiktokAdsSpend, chartBenchmarksTiktokAdsClicksAvg],
  (spend, clicks) => simpleChart2(spend, clicks)
);

const totalBenchmarksCTRTiktok = createSelector(
  [totalBenchmarksTiktokAdsImpressionsAvg, totalBenchmarksTiktokAdsClicksAvg],
  (impressions, clicks) => safeDivide(clicks, impressions) * 100
);

const chartBenchmarksCTRTiktok = createSelector(
  [chartBenchmarksTiktokAdsImpressionsAvg, chartBenchmarksTiktokAdsClicksAvg],
  (impressions, clicks) =>
    simpleChart2(clicks, impressions, { chart1yMultiplier: 100 })
);


// Google ads benchmarks
const totalBenchmarksTotalConversionValueGoogleAvg = createSelector(
  [getNewStats],
  (stats) => {
    return total(stats, "conversionValue_google");
  }
);

const chartBenchmarksTotalConversionValueGoogleAvg = createSelector(
  [getNewStats],
  (stats) => {
    return simpleChart(stats, "conversionValue_google");
  }
);

const totalBenchmarksGoogleAdsSpend = createSelector([getNewStats], (stats) => {
  return total(stats, "spend_google");
});
const totalBenchmarksGoogleAdsSpendAvg = createSelector(
  [getNewStats],
  (stats) => {
    return total(stats, "spend_google_avg");
  }
);

const chartBenchmarksGoogleAdsSpendAvg = createSelector(
  [getNewStats],
  (stats) => {
    return simpleChart(stats, "spend_google_avg");
  }
);

const chartBenchmarksGoogleAdsSpend = createSelector([getNewStats], (stats) => {
  return simpleChart(stats, "spend_google");
});

const totalBenchmarksGoogleAdsImpressionsAvg = createSelector(
  [getNewStats],
  (stats) => {
    return total(stats, "impressions_google");
  }
);

const chartBenchmarksGoogleAdsImpressionsAvg = createSelector(
  [getNewStats],
  (stats) => {
    return simpleChart(stats, "impressions_google");
  }
);

const totalBenchmarksGoogleAdsClicksAvg = createSelector(
  [getNewStats],
  (stats) => {
    return total(stats, "clicks_google");
  }
);

const chartBenchmarksGoogleAdsClicksAvg = createSelector(
  [getNewStats],
  (stats) => {
    return simpleChart(stats, "clicks_google");
  }
);

const benchmarksGoogleRoas = createSelector(
  [totalBenchmarksTotalConversionValueGoogleAvg, totalBenchmarksGoogleAdsSpend],
  (conversionValue, spend) => safeDivide(conversionValue, spend)
);

const chartBenchmarksGoogleRoas = createSelector(
  [chartBenchmarksTotalConversionValueGoogleAvg, chartBenchmarksGoogleAdsSpend],
  (conversionValue, spend) => simpleChart2(conversionValue, spend)
);

const totalBenchmarksCPCGoogle = createSelector(
  [totalBenchmarksGoogleAdsSpend, totalBenchmarksGoogleAdsClicksAvg],
  (spend, clicks) => safeDivide(spend, clicks)
);

const chartBenchmarksCPCGoogle = createSelector(
  [chartBenchmarksGoogleAdsSpend, chartBenchmarksGoogleAdsClicksAvg],
  (spend, clicks) => simpleChart2(spend, clicks)
);

const totalBenchmarksCTRGoogle = createSelector(
  [totalBenchmarksGoogleAdsImpressionsAvg, totalBenchmarksGoogleAdsClicksAvg],
  (impressions, clicks) => safeDivide(clicks, impressions) * 100
);

const chartBenchmarksCTRGoogle = createSelector(
  [chartBenchmarksGoogleAdsImpressionsAvg, chartBenchmarksGoogleAdsClicksAvg],
  (impressions, clicks) =>
    simpleChart2(clicks, impressions, { chart1yMultiplier: 100 })
);

const totalBenchmarksCPMGoogle = createSelector(
  [totalBenchmarksGoogleAdsImpressionsAvg, totalBenchmarksGoogleAdsSpend],
  (impressions, spend) => safeDivide(spend, impressions / 1000)
);

const chartBenchmarksCPMGoogle = createSelector(
  [chartBenchmarksGoogleAdsImpressionsAvg, chartBenchmarksGoogleAdsSpend],
  (impressions, spend) =>
    simpleChart2(spend, impressions, { chart1yMultiplier: 1000 })
);

// Blended benchmarks

const totalBenchmarksCPC = createSelector(
  [totalBenchmarksFBAdsSpend, totalBenchmarksFBAdsClicksAvg],
  (spend, clicks) => safeDivide(spend, clicks)
);
const chartBenchmarksCPC = createSelector(
  [chartBenchmarksFBAdsSpend, chartBenchmarksFBAdsClicksAvg],
  (spend, clicks) => simpleChart2(spend, clicks)
);

const totalBenchmarksCTR = createSelector(
  [totalBenchmarksFBAdsImpressionsAvg, totalBenchmarksFBAdsClicksAvg],
  (impressions, clicks) => safeDivide(clicks, impressions) * 100
);

const chartBenchmarksCTR = createSelector(
  [chartBenchmarksFBAdsImpressionsAvg, chartBenchmarksFBAdsClicksAvg],
  (impressions, clicks) =>
    simpleChart2(clicks, impressions, { chart1yMultiplier: 100 })
);

const totalBenchmarksCPM = createSelector(
  [totalBenchmarksFBAdsImpressionsAvg, totalBenchmarksFBAdsSpend],
  (impressions, spend) => safeDivide(spend, impressions / 1000)
);

const chartBenchmarksCPM = createSelector(
  [chartBenchmarksFBAdsImpressionsAvg, chartBenchmarksFBAdsSpendAvg],
  (impressions, spend) =>
    simpleChart2(spend, impressions, { chart1yMultiplier: 1000 })
);

const totalBenchmarksBlendedSpendAvg = createSelector(
  [getNewStatsWithBlended],
  (stats) => {
    return total(stats, "blended_spend");
  }
);

const chartBenchmarksTotalPriceUSDAvg = createSelector(
  [getNewStatsWithBlended],
  (stats) => {
    return simpleChart(stats, "blended_spend");
  }
);

const totalBenchmarksBlendedFullSpend = createSelector(
  [getNewStatsWithBlended],
  (stats) => {
    return total(stats, "blended_full_spend");
  }
);

const chartBenchmarksBlendedFullSpend = createSelector(
  [getNewStatsWithBlended],
  (stats) => {
    return simpleChart(stats, "blended_full_spend");
  }
);

const totalBenchmarksBlendedConversioValue = createSelector(
  [getNewStatsWithBlended],
  (stats) => {
    return total(stats, "blended_cv");
  }
);

const chartBenchmarksBlendedConversioValue = createSelector(
  [getNewStatsWithBlended],
  (stats) => {
    return simpleChart(stats, "blended_cv");
  }
);

const totalBenchmarksBlendedImpressions = createSelector(
  [getNewStatsWithBlended],
  (stats) => {
    return total(stats, "blended_impressions");
  }
);

const chartBenchmarksBlendedImpressions = createSelector(
  [getNewStatsWithBlended],
  (stats) => {
    return simpleChart(stats, "blended_impressions");
  }
);

const totalBenchmarksBlendedClicks = createSelector(
  [getNewStatsWithBlended],
  (stats) => {
    return total(stats, "blended_clicks");
  }
);

const chartBenchmarksBlendedClicks = createSelector(
  [getNewStatsWithBlended],
  (stats) => {
    return simpleChart(stats, "blended_clicks");
  }
);

const totalBenchmarksBlendedROAS = createSelector(
  [totalBenchmarksBlendedConversioValue, totalBenchmarksBlendedFullSpend],
  (sales, spend) => safeDivide(sales, spend)
);

const chartBenchmarksBlendedROAS = createSelector(
  [chartBenchmarksBlendedConversioValue, chartBenchmarksBlendedFullSpend],
  (sales, spend) => simpleChart2(sales, spend)
);

const totalBenchmarksBlendedCpc = createSelector(
  [totalBenchmarksBlendedFullSpend, totalBenchmarksBlendedClicks],
  (spend, clicks) => safeDivide(spend, clicks)
);

const chartBenchmarksBlendedCpc = createSelector(
  [chartBenchmarksBlendedFullSpend, chartBenchmarksBlendedClicks],
  (spend, clicks) => simpleChart2(spend, clicks)
);

const totalBenchmarksBlendedCTR = createSelector(
  [totalBenchmarksBlendedClicks, totalBenchmarksBlendedImpressions],
  (clicks, impressions) => {
    return safeDivide(clicks, impressions) * 100;
  }
);

const chartBenchmarksBlendedCTR = createSelector(
  [chartBenchmarksBlendedClicks, chartBenchmarksBlendedImpressions],
  (clicks, impressions) => simpleChart2(clicks, impressions, { chart1yMultiplier: 100 })
);

// newCustomerRevenue/blended
const totalBenchmarksNCROAS = createSelector(
  [totalBenchmarksNewCustomersTotalPriceAvg, totalBenchmarksTotalSpendAvg],
  (ncRevenue, spend) => safeDivide(ncRevenue, spend)
);

const chartBenchmarksNCROAS = createSelector(
  [chartBenchmarksFBAdsImpressionsAvg, chartBenchmarksTotalSpendAAvg],
  (ncRevenue, spend) => simpleChart2(ncRevenue, spend)
);

const totalBenchmarksNCPA = createSelector(
  [totalBenchmarksTotalSpendAvg, totalBenchmarksNewCustomersAvg],
  (spend, newCustomers) => safeDivide(spend, newCustomers)
);
const chartBenchmarksNCPA = createSelector(
  [chartBenchmarksTotalSpendAAvg, chartBenchmarksFBAdsNewCustomersAvg],
  (spend, newCustomers) => simpleChart2(spend, newCustomers)
);

const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    totalBenchmarksCPM,
    totalBenchmarksCPC,
    totalBenchmarksCTR,
    totalBenchmarksNCROAS,
    totalBenchmarksBlendedROAS,
    totalBenchmarksBlendedCTR,
    totalBenchmarksNCPA,
    totalBenchmarksTotalSpendAvg,
    chartBenchmarksTotalSpendAAvg,
    totalBenchmarksNewCustomersAvg,
    chartBenchmarksFBAdsNewCustomersAvg,
    totalBenchmarksSize,
    chartBenchmarksSize,
    totalBenchmarksOrdersAvg,
    chartBenchmarksOrdersAvg,
    totalBenchmarksNewCustomersTotalPriceAvg,
    chartBenchmarksNewCustomersTotalPriceAvg,
    totalBenchmarksBlendedSpendAvg,
    chartBenchmarksTotalPriceUSDAvg,
    totalBenchmarksFBAdsSpendAvg,
    totalBenchmarksFBAdsSpend,
    chartBenchmarksFBAdsSpendAvg,
    totalBenchmarksFBAdsImpressionsAvg,
    chartBenchmarksFBAdsImpressionsAvg,
    totalBenchmarksFBAdsClicksAvg,
    chartBenchmarksFBAdsClicksAvg,
    totalBenchmarksBlendedCpc,

    chartBenchmarksCPC,
    chartBenchmarksCTR,
    chartBenchmarksCPM,
    benchmarksFacebookRoas,
    chartBenchmarksFacebookRoas,
    chartBenchmarksNCROAS,
    chartBenchmarksNCPA,
    chartBenchmarksBlendedROAS,
    chartBenchmarksBlendedCTR,

    totalBenchmarksTotalConversionValueAvg,
    chartBenchmarksTotalConversionValueAvg,
    totalBenchmarksGoogleAdsImpressionsAvg,
    chartBenchmarksGoogleAdsImpressionsAvg,
    totalBenchmarksGoogleAdsClicksAvg,
    chartBenchmarksGoogleAdsClicksAvg,
    totalBenchmarksGoogleAdsSpendAvg,
    totalBenchmarksGoogleAdsSpend,
    chartBenchmarksGoogleAdsSpendAvg,
    totalBenchmarksTotalConversionValueGoogleAvg,
    chartBenchmarksTotalConversionValueGoogleAvg,
    benchmarksGoogleRoas,
    chartBenchmarksGoogleRoas,
    totalBenchmarksCPCGoogle,
    chartBenchmarksCPCGoogle,
    totalBenchmarksCTRGoogle,
    chartBenchmarksCTRGoogle,
    totalBenchmarksCPMGoogle,
    chartBenchmarksCPMGoogle,
    chartBenchmarksBlendedCpc,

    totalBenchmarksCPCTiktok,
    chartBenchmarksCPCTiktok,
    totalBenchmarksCTRTiktok,
    chartBenchmarksCTRTiktok,
    totalBenchmarksTotalConversionValueTiktokAvg,
    chartBenchmarksTotalConversionValueTiktokAvg,
    totalBenchmarksTiktokAdsSpend,
    chartBenchmarksTiktokAdsSpend,
    totalBenchmarksTiktokAdsSpendAvg,
    chartBenchmarksTiktokAdsSpendAvg,
    totalBenchmarksTiktokAdsImpressionsAvg,
    chartBenchmarksTiktokAdsImpressionsAvg,
    totalBenchmarksTiktokAdsClicksAvg,
    chartBenchmarksTiktokAdsClicksAvg,
    benchmarksTiktokRoas,
    chartBenchmarksTiktokRoas
  },
};
